// services/surveyCategoryService.js
import { surveyCategoriesAPI } from './api';

export const surveyCategoryService = {
  async getSurveyCategories(surveyId) {
    try {
      console.log('🔄 Fetching categories for survey:', surveyId);
      
      // FIX: Use the correct endpoint that matches your backend
      const response = await surveyCategoriesAPI.getBySurvey(surveyId);
      
      console.log('✅ Categories response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching survey categories:', error);
      
      // Enhanced error logging
      console.error('Error details:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url
      });
      
      throw new Error(error.response?.data?.message || 'Failed to load survey categories');
    }
  },

  async getSurveyCategory(id) {
    try {
      const response = await surveyCategoriesAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching survey category:', error);
      throw new Error(error.response?.data?.message || 'Failed to load survey category');
    }
  },

  async createSurveyCategory(category) {
    try {
      console.log('📤 Creating survey category:', category);
      const response = await surveyCategoriesAPI.create(category);
      console.log('✅ Survey category created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating survey category:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to create survey category';
      throw new Error(errorMessage);
    }
  },

  async updateSurveyCategory(id, category) {
    try {
      console.log(`📤 Updating survey category ${id}:`, category);
      const response = await surveyCategoriesAPI.update(id, category);
      console.log('✅ Survey category updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating survey category:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to update survey category';
      throw new Error(errorMessage);
    }
  },

  async deleteSurveyCategory(id) {
    try {
      await surveyCategoriesAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting survey category:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete survey category');
    }
  },

  async reorderCategories(categoryOrders) {
    try {
      const response = await surveyCategoriesAPI.reorder(categoryOrders);
      return response.data;
    } catch (error) {
      console.error('❌ Error reordering categories:', error);
      throw new Error(error.response?.data?.message || 'Failed to reorder categories');
    }
  }
};